import { render } from "./ClientCallSquadList.vue?vue&type=template&id=ac7c727c"
import script from "./ClientCallSquadList.vue?vue&type=script&lang=js"
export * from "./ClientCallSquadList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__